export const ALGO_ACTION_TYPES = {
  SET_ALGORITHM: 'algo/SET_ALGORITHM',
  SET_IS_ALGO_DROPDOWN_OPEN: 'algo/SET_IS_ALGO_DROPDOWN_OPEN',
};

export const ALGO_TYPES = {
  ASTAR: 'A* Search',
  ASTAR_WEIGHTED: 'Weighted A* Search',
  BFS: 'Breadth First Search',
  DFS: 'Depth First Search',
  DIJKSTRAS: "Dijkstra's Algorithm",
  GREEDY: 'Greedy Best First Search',
};
